import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";

export const ResetPasswordSentModal = ({
                               email,
                               isEmailSent,
                               handleCloseEmailSent
                           }) => {
    const { t } = useTranslation();

    return (


        <Modal show={isEmailSent} onHide={handleCloseEmailSent}>
            <Modal.Body>
                <div className="promocode_content signout invite request">
                    <Link to="" onClick={handleCloseEmailSent}>
                        +
                    </Link>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
                        <h2>{t("Password Reset Sent")}</h2>
                        <p>{t("If an account exists for")} {email}, {t("We’ll send you a reset link to create a new password.")}</p>
                        <p><b>{t("Don’t see it?")}</b> {t("Be sure to check your spam or junk folder.")}</p>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
);
};
